module.exports = __webpack_public_path__ + "c0ecc24c19b2656a1441e7c601ec39e4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/futura_book/futura_book.woff
// module id = 916
// module chunks = 0